import { minBreakpoints, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var header = /*#__PURE__*/css(["min-height:", ";position:relative;margin:", ";", ""], pxToRem(36), stack(spacing.lg), mediaQuery({
  min: minBreakpoints.L
}, css(["margin:", ";"], stack(spacing.xl))));
export var controls = /*#__PURE__*/css(["display:none;justify-content:flex-end;border:none;padding:0;margin:0;", ""], mediaQuery({
  min: minBreakpoints.S
}, css(["display:flex;"])));
export var title = /*#__PURE__*/css(["margin:auto;text-align:var(--titleAlignment);color:var(--neutral-black-base);", ""], mediaQuery({
  min: minBreakpoints.S
}, css(["position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;pointer-events:none;"])));
export var titleRegular = /*#__PURE__*/css(["", ";"], responsiveFontSize({
  XXS: {
    fontSize: 20,
    lineHeight: 32
  }
}));
var TITLE_SMALL_SIZE = 16;
export var titleSmall = /*#__PURE__*/css(["", ";"], responsiveFontSize({
  XXS: {
    fontSize: TITLE_SMALL_SIZE,
    lineHeight: 36
  }
}));
export var carouselContent = /*#__PURE__*/css(["overflow-x:auto;", " -ms-overflow-style:none;", " scrollbar-width:none;&::-webkit-scrollbar{display:none;}scroll-behavior:auto;scroll-snap-type:x mandatory;"], /* IE and Edge */'', /* Firefox */'');
export var carouselWrapper = /*#__PURE__*/css(["display:flex;flex-direction:row;padding:0;margin:", " 0;list-style-type:none;li{display:inline-block;scroll-snap-align:start;scroll-snap-stop:normal;", " margin-right:var(--columnGap);}li:last-child{margin-right:0;}"], pxToRem(spacing.base), /* Using margin-right because column-gap within display flex isn't supported prior to Safari 14 */'');